import React from 'react';

class PlayerOptionsDropdown extends React.Component
{
  constructor( props )
  {
    super( props );
    this.dropdownRef = React.createRef();
  }

  componentDidMount()
  {
    document.addEventListener( 'mousedown', this.handleClickOutside );
  }

  componentWillUnmount()
  {
    document.removeEventListener( 'mousedown', this.handleClickOutside );
  }

  handleClickOutside = ( event ) =>
  {
    if( this.dropdownRef.current && !this.dropdownRef.current.contains( event.target ) )
    {
      this.props.onClose();
    }
  };

  render()
  {
    const {
      playerInfo,
      isBot,
      isRoomHost,
      isClientEntry,
      currentBotIndex,
      onClose
    } = this.props;

    // Determine what options are available
    const hasViewProfile = !isBot;
    const hasEditUsername = isClientEntry;
    const hasKickPlayer = isRoomHost && !isClientEntry;

    // Don't render dropdown if no options are available
    if( !hasViewProfile && !hasEditUsername && !hasKickPlayer )
    {
      return null;
    }

    return (
      <div
        ref={ this.dropdownRef }
        className="player-options-dropdown"
      >
        <div className="player-options-dropdown-content">
          {/* View Profile - always available for human players */ }
          { hasViewProfile && (
            <div
              className="player-options-dropdown-item"
              onClick={ () =>
              {
                const baseUrl = window.location.origin;
                const profileUrl = `${baseUrl}/profile/${playerInfo.username}`;
                window.open( profileUrl, '_blank' );
                onClose();
              } }
            >
              <img
                className="player-options-dropdown-item-icon"
                src={ process.env.PUBLIC_URL + '/ui/human-icon.png' }
                alt="Profile icon"
              />
              <span>View Profile</span>
            </div>
          ) }

          {/* Edit Username - only for client's own entry */ }
          { hasEditUsername && (
            <>
              { hasViewProfile && <div className="player-options-dropdown-separator" /> }
              <div
                className="player-options-dropdown-item"
                onClick={ () =>
                {
                  this.props.onEditUsername();
                  onClose();
                } }
              >
                <img
                  className="player-options-dropdown-item-icon"
                  src={ process.env.PUBLIC_URL + '/ui/icon-pencil.svg' }
                  alt="Edit icon"
                />
                <span>Edit Username</span>
              </div>
            </>
          ) }

          {/* Kick Player/Bot - only for room host */ }
          { hasKickPlayer && (
            <>
              { ( hasViewProfile || hasEditUsername ) && <div className="player-options-dropdown-separator" /> }
              <div
                className="player-options-dropdown-item player-options-dropdown-item-danger"
                onClick={ () =>
                {
                  this.props.onKickPlayer( isBot, currentBotIndex, playerInfo );
                  onClose();
                } }
              >
                <img
                  className="player-options-dropdown-item-icon"
                  src={ process.env.PUBLIC_URL + '/ui/icon-x.svg' }
                  alt="Kick icon"
                />
                <span>Kick { isBot ? "Bot" : "Player" }</span>
              </div>
            </>
          ) }
        </div>
      </div>
    );
  }
}

export default PlayerOptionsDropdown;
